import React from "react"
import { Col, Label } from "reactstrap"
import KycDocumentUpload from "./kycDocumentUpload"
import UploadedFileBox from "./uploadedFileBox"

const errorMessage = "Please upload file in PDF format only."
const preview = true

const RenderBusinessType = ({ type, validation, kycData }) => {
  switch (type) {
    case "Private Limited Company":
    case "Public Limited Company":
    case "One Person Company":
      return <CompanyComponent validation={validation} kycData={kycData} />
    case "Limited Liability Partnership":
      return <LLP validation={validation} kycData={kycData} />
    case "Sole Proprietorship":
    case "Partnership Firm":
      return <Partnership validation={validation} kycData={kycData} />
    case "Hindu Undivided Family":
      return <HUF validation={validation} kycData={kycData} />
    case "Co-operative Society":
    case "Trust/Association of Persons":
      return <SocietyAndTrust validation={validation} kycData={kycData} />
    default:
      return null // or some fallback UI
  }
}

export default RenderBusinessType

function CompanyComponent({ validation, kycData }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Memorandum of Association <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"memorandum_of_association"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Articles of Association <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"articles_of_association"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Certifcate of Incorporation <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
            kycData={kycData}
          />
        </Col>
      )}
    </>
  )
}

function LLP({ validation, kycData }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Initial LLP Deed <span className="error">*</span>
        </Label>
        <KycDocumentUpload
          fieldKey={"initial_llp_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">
          Latest LLP Deed <span className="error">*</span>
        </Label>
        <KycDocumentUpload
          fieldKey={"latest_llp_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Certificate of Incorporation</Label>
        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
            kycData={kycData}
          />
        </Col>
      )}
    </>
  )
}

function Partnership({ validation, kycData }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Initial Partnership Deed <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"initial_partnership_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Latest Partnership Deed</Label>
        <KycDocumentUpload
          fieldKey={"latest_partnership_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      <Col xl={12}>
        <Label className="col-form-label">Certificate of Incorporation</Label>
        <KycDocumentUpload
          fieldKey={"certificate_of_incorporation"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>
          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
            kycData={kycData}
          />
        </Col>
      )}
    </>
  )
}

function HUF({ validation, kycData }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          HUF Creation Document <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"huf_creation_document"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
    </>
  )
}
function SocietyAndTrust({ validation, kycData }) {
  return (
    <>
      <Col xl={12}>
        <Label className="col-form-label">
          Trust Deed <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"trust_deed"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>

      <Col xl={12}>
        <Label className="col-form-label">
          Society Bye-Laws <span className="error">*</span>
        </Label>

        <KycDocumentUpload
          fieldKey={"society_bye_laws"}
          validation={validation}
          extensionAllowedInput=".pdf"
          extensionAllowed={["application/pdf"]}
          typeError={errorMessage}
          preview={preview}
          kycData={kycData}
        />
      </Col>
      {validation.values.showGSTIN && (
        <Col xl={12}>
          <Label className="col-form-label">
            GSTIN Certificate <span className="error">*</span>
          </Label>

          <KycDocumentUpload
            fieldKey={"gstin_certificate"}
            validation={validation}
            extensionAllowedInput=".pdf"
            extensionAllowed={["application/pdf"]}
            typeError={errorMessage}
            preview={preview}
            kycData={kycData}
          />
        </Col>
      )}
    </>
  )
}
